import { PDFDocument, rgb } from "pdf-lib";
import { pdfImg, pdfImgTop } from "../settings";
import { getLouverMeshNames } from "../Meshconfig";

// import * as pdfMake from "pdfmake/build/pdfmake";
// import * as pdfFonts from "pdfmake/build/vfs_fonts";

import * as fontkit from "fontkit";
import $ from "jquery";
import { GetGroup, CreateImageList, toggleBackWall } from "../3d-configurator";


async function convertToBlackAndWhite(imageBytes) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const image = new Image();
    image.src = URL.createObjectURL(
      new Blob([imageBytes], { type: "image/png" })
    );

    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;

      ctx.drawImage(image, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        const avg = (r + g + b) / 3;

        data[i] = data[i + 1] = data[i + 2] = avg;
      }

      ctx.putImageData(imageData, 0, 0);

      canvas.toBlob(async (blob) => {
        const bwImageBytes = await blob.arrayBuffer();
        resolve(bwImageBytes);
      }, "image/png");
    };

    image.onerror = reject;
  });
}

const pdf_logo_url = "public/img/water-mark-black.png";
const pdf_water_mark_url = "public/img/water-mark.png";
const pdf_icon_web_url =
  "https://s3.eu-central-1.amazonaws.com/marevo.vision/RelevantProjects/webAR/Marevo-KL/Louvertec/pdf_icons/marevo-icon-web.png";
const pdf_icon_phone_url =
  "https://s3.eu-central-1.amazonaws.com/marevo.vision/RelevantProjects/webAR/Marevo-KL/Louvertec/pdf_icons/marevo-icon-phone.png";
const pdf_icon_email_url =
  "https://s3.eu-central-1.amazonaws.com/marevo.vision/RelevantProjects/webAR/Marevo-KL/Louvertec/pdf_icons/marevo-icon-email.png";

export async function createPDF(opt = "download") {

  const originalWallStates = {
    backWall: state.backWall,
  };

  try {
    state.backWall = false;
    if (typeof toggleBackWall === 'function') toggleBackWall(false);

    state.pdfMode = true;
    await CreateImageList();
    state.pdfMode = false;

    const uiPdfPhone = "1300 771 902";
    const uiPdfEmail = "info@louvretec.com.au";
    const uiPdfWeb = "www.louvretec.com.au";
    const mainMargins = [30, 100, 30, 70];

    const imageUrls = [
      pdf_logo_url,
      pdf_icon_web_url,
      pdf_icon_phone_url,
      pdf_icon_email_url,
      pdf_water_mark_url,
    ];

    const imageDataUrls = await Promise.all(
      imageUrls.map(async (imageUrl) => {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const reader = new FileReader();
        return await new Promise((resolve, reject) => {
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      })
    );

    const [
      logoImage,
      websiteIconImage,
      phoneIconImage,
      emailIconImage,
      waterMarkImage,
    ] = imageDataUrls;

    function rgbToHex(rgb) {
      const result = rgb.match(/\d+/g);
      if (!result) return "#000000";
      return `#${parseInt(result[0]).toString(16).padStart(2, "0")}${parseInt(
        result[1]
      )
        .toString(16)
        .padStart(2, "0")}${parseInt(result[2]).toString(16).padStart(2, "0")}`;
    }

    const footerColorWhite = "#ffffff";
    const footerColor = "#629A33";

    const footerContent = function () {
      return [
        {
          margin: [0, 20, 0, 0],
          table: {
            widths: [12, "auto", "*", 12, "auto", "*", 12, "auto"],
            body: [
              [
                {
                  image: phoneIconImage,
                  margin: [0, 17, -30, 30],
                  width: 10,
                  height: 10,
                  alignment: "center",
                  style: "footer",
                },
                {
                  text: uiPdfPhone,
                  margin: [30, 15, 0, 30],
                  alignment: "center",
                  style: "footer",
                  color: footerColorWhite,
                },
                { text: "" },
                {
                  image: websiteIconImage,
                  width: 10,
                  height: 10,
                  alignment: "center",
                  margin: [0, 17, 0, 30],
                },
                {
                  text: uiPdfWeb,
                  link: uiPdfWeb,
                  margin: [0, 15, 0, 30],
                  alignment: "center",
                  style: "footer",
                  color: footerColorWhite,
                },
                { text: "" },
                {
                  image: emailIconImage,
                  width: 10,
                  height: 10,
                  alignment: "center",
                  margin: [0, 17, 0, 30],
                },
                {
                  text: uiPdfEmail,
                  link: `mailto:${uiPdfEmail}`,
                  margin: [0, 15, 30, 30],
                  alignment: "center",
                  style: "footer",
                  color: footerColorWhite,
                },

              ],
            ],
          },
          fillColor: footerColor,
          layout: "noBorders",
        },
      ];
    };

    function loadImageAsDataUrl(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = function () {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = () => reject("Image load error");
        img.src = url;
      });
    }

    function generateRectangleImage(colorHex) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = 30;
      canvas.height = 18;

      ctx.fillStyle = colorHex;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      return canvas.toDataURL("image/png");
    }

    async function generatePDFcontentFromOverview() {
      const itemsOverview = $(".sum__page__main-list__item");
      const itemsData = $(".title_data")
      const content = [];

      for (const item of itemsOverview) {
        const $item = $(item);
        const title = $item
          .find(".sum__page__main-list__title")
          .text()
          .toUpperCase();
        const list = $item.find(".sum__page__main-list__info");
        const itemList = [];

        for (const info of list) {
          const $info = $(info);
          const $infoTitleEl = $info.find(".sum__page__main-list__info__title");
          const infoTitle = $infoTitleEl.text();
          const isTitleData = $infoTitleEl.hasClass("title_data");
          const $colorElement = $info.find(".sum__page__main-list__info__color");
          const bgColor = $colorElement.css("background-color");
          const bgImage = $colorElement.css("background-image");
          const value = $info.find(".sum__page__main-list__info__param").text();

          const result = [];

          if (bgImage && bgImage !== "none") {
            const match = bgImage.match(/url\(["']?(.*?)["']?\)/);
            if (match && match[1]) {
              let imageUrl = match[1].replace(/^public\//, "/");
              try {
                const imageDataUrl = await loadImageAsDataUrl(imageUrl);
                result.push({
                  image: imageDataUrl,
                  width: 20,
                  height: 20,
                  alignment: "left",
                  style: "itemValue",
                  margin: [0, 10, 0, 0],
                  border: [false, false, false, false],
                });
              } catch {
                result.push({ text: infoTitle, style: "itemFirst" });
              }
            }
          } else if (
            bgColor &&
            bgColor !== "rgba(0, 0, 0, 0)" &&
            bgColor !== "transparent"
          ) {
            const colorHex = rgbToHex(bgColor);
            const ellipseImg = generateRectangleImage(colorHex);
            result.push({
              image: ellipseImg,
              width: 30,
              height: 18,
              alignment: "left",
              style: "itemValue",
              margin: [0, 0, 0, 0],
              border: [false, false, false, false],
            });
          } else {
            result.push({
              text: infoTitle,
              style: "itemFirst",
              color: isTitleData ? "#629A33" : "black",
              border: [false, false, false, false],
              margin: [0, 10, 0, 0],
            });
          }

          result.push({
            text: value,
            style: "itemValueFirst",
            border: [false, false, false, false],
            margin: [0, 10, 0, 0],
          });

          itemList.push(result);
        }

        content.push({
          style: "tableItemLeft",
          table: {
            widths: "*",
            body: [
              [
                {
                  text: title,
                  style: "tableHeader",
                  colSpan: 2,
                  border: [false, false, false, false],
                },
                {},
              ],
              [
                {
                  text: "",
                  colSpan: 2,
                  border: [false, true, false, false],
                  borderColor: [null, '#629A33', null, null],
                  height: 1,
                },
                {},
              ],
              ...itemList,
            ],
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0,
            hLineColor: () => '#629A33',
          },
        });
      }

      return content;
    }

    const overviewContent = await generatePDFcontentFromOverview();

    const pdfContent = [
      {
        text: 'All measurements, design and placement are approximate and subject for approval upon execution of order.',
        style: 'pageDescription',
        alignment: 'center',
        margin: [30, 0, 0, 25],
      },
      {
        margin: [0, 0, 0, 10],
        columns: [
          { image: pdfImg.img, fit: [265, 180], margin: [0, 0, 0, 0] },
          { image: pdfImgTop.img, fit: [265, 180], margin: [0, 0, 0, 0] },
        ],
      },
      { image: waterMarkImage, width: 165, height: 120, absolutePosition: { x: 40, y: 150 } },
      { image: waterMarkImage, width: 165, height: 120, absolutePosition: { x: 220, y: 150 } },
      { image: waterMarkImage, width: 165, height: 120, absolutePosition: { x: 380, y: 150 } },
      ...overviewContent,
    ];

    const pdfDefinition = {
      pageMargins: mainMargins,
      background: function (currentPage, pageSize) {
        return {
          canvas: [],
          stack: [
            // Row 1
            {
              columns: [
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
              ],
              absolutePosition: { x: 50, y: 150 },
            },
            // Row 2
            {
              columns: [
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
              ],
              absolutePosition: { x: 50, y: 350 },
            },
            // Row 3
            {
              columns: [
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
              ],
              absolutePosition: { x: 50, y: 550 },
            },
            // Row 4
            {
              columns: [
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
                { image: waterMarkImage, width: 165, height: 120, opacity: 0.95 },
              ],
              absolutePosition: { x: 50, y: 750 },
            },
          ],
        };
      },
      header: {
        stack: [
          { image: logoImage, width: 246, height: 48 },
        ],
        alignment: "center",
        margin: [0, 30, 0, 10],
      },
      content: pdfContent,
      footer: footerContent(),
      styles: {
        tableHeader: {
          fontSize: 10,
          bold: true,
          color: "black",
          alignment: "center",
          margin: [0, 15, 0, 10],
        },
        itemFirst: {
          fontSize: 10,
          color: "black",
          alignment: "left",
        },
        itemValue: {
          fontSize: 10,
          color: "#629A33",
          alignment: "right",
        },
        itemValueFirst: {
          fontSize: 10,
          color: "#629A33",
          alignment: "right",
        },
        lineStyle: {
          margin: [0, 0, 0, 2],
        },
        tableItemLeft: {
          fontSize: 10,
          margin: [0, 0, 0, 0],
        },
        pageDescription: {
          fontSize: 14,
          color: '#629A33',
          italics: false,
        },
      },
      defaultStyle: {
        font: "Roboto",
      },
    };

    switch (opt) {
      case "open":
        pdfMake.createPdf(pdfDefinition).open();
        break;
      case "download":
        pdfMake.createPdf(pdfDefinition).download("Louvretec.pdf");
        break;
      case "print":
        pdfMake.createPdf(pdfDefinition).print();
        break;
    }
  } finally {
    state.pdfMode = false;
    state.backWall = originalWallStates.backWall;
    pergola.update();
  }
}
